import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import styled from '@emotion/styled';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import { ActionSubject } from '@atlassian/proforma-utils/analytics';
// eslint-disable-next-line @repo/internal/react/no-class-components
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorInfo: null,
      error: null
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error,
      errorInfo: errorInfo.componentStack
    });
    this.props.errorUtils.reportError(error, {
      actionSubject: ActionSubject.PROFORMA_UI,
      id: 'errorBoundary',
      errorInfo
    });
  }
  render() {
    if (this.state.hasError) {
      // Render error UI here
      const {
        renderError
      } = this.props;
      return renderError ? renderError({
        error: this.state.error
      }) : /*#__PURE__*/React.createElement(ErrorPage, null, /*#__PURE__*/React.createElement(ErrorPageSection, null, /*#__PURE__*/React.createElement(SectionMessage, {
        appearance: "error",
        title: "Something went wrong"
      }, /*#__PURE__*/React.createElement(Text, {
        as: "p"
      }, "Refresh the page and try again. ", /*#__PURE__*/React.createElement("br", null), "If the error persists,", ' ', fg('dst-a11y__replace-anchor-with-link__jira-service-m') ? /*#__PURE__*/React.createElement(Link, {
        href: "https://support.thinktilt.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "contact support") :
      /*#__PURE__*/
      // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
      React.createElement("a", {
        href: "https://support.thinktilt.com",
        target: "_blank",
        rel: "noopener noreferrer"
      }, "contact support"), "."))));
    }
    return this.props.children;
  }
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorPage = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const ErrorPageSection = styled.div({});